<template>
  <v-container class="pa-0 ">
    <div>
      <h1>Zorgplanner</h1>
    </div>
    <div class="appointments">
      <p>
        Klik op een afspraak of reservering om de details te bekijken en te
        bewerken.
      </p>

      <v-btn
        class="btn-regular"
        depressed
        @click.stop="$router.push({ name: 'new-appointment' })"
      >
        Afspraak toevoegen
      </v-btn>

      <v-btn
        v-if="false"
        class="btn-confirm"
        depressed
        @click.stop="$router.push({ name: 'new-reservation' })"
      >
        Reservering toevoegen
      </v-btn>

      <h5 class="subtitle">Afspraken:</h5>
      <p class="appointment-p" v-if="appointments.length == 0">
        Er zijn nog geen afspraken.
      </p>
      <div
        class="block appointment"
        v-for="appointment in appointments"
        :key="`appointment-${appointment.id}`"
        @click="$router.push({ path: 'my-appointments/' + appointment.id })"
      >
        <p class="appt-date">
          {{ dateFormatFriendly(appointment.date) }}
          {{ appointment.start_block.start }} - {{ appointment.end_block.end }}
        </p>
        <p class="location">
          {{ appointment.room.practice.name }} - {{ appointment.room.title }}
        </p>
        <p class="comment">{{ appointment.comment }}</p>
        <p v-if="appointment.materialsHtml">{{ appointment.materialsHtml }}</p>
      </div>
      <div v-if="reservations.length">
        <h5 class="subtitle">Reserveringen:</h5>
        <p class="reservation-p" v-if="reservations.length == 0">
          Er zijn nog geen reserveringen.
        </p>
        <div
          class="block reservation"
          v-for="reservation in reservations"
          :key="`reservation-${reservation.id}`"
          @click="$router.push({ path: 'my-appointments/' + reservation.id })"
        >
          <p class="appt-date">
            {{ dateFormatFriendly(reservation.date) }}
            {{ reservation.start_block.start }} -
            {{ reservation.end_block.end }}
          </p>
          <p class="location">
            {{ reservation.room.practice.name }} - {{ reservation.room.title }}
          </p>
          <p class="comment">{{ reservation.comment }}</p>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import BackendService from "../services/BackendService";

export default {
  data: () => ({
    step: 1,
    appointments: [],
    reservations: []
  }),
  methods: {
    dateFormatFriendly(d) {
      return window.dateFormatFriendly(d);
    }
  },
  created() {
    BackendService.getAppointments()
      .then(response => {
        this.appointments = response.data;
      })
      .catch(err => {
        console.log(err);
      }),
      BackendService.getReservations()
        .then(response => {
          this.reservations = response.data;
        })
        .catch(err => {
          console.log(err);
        });
  },
  watch: {
    $route: "my-appointments"
  }
};
</script>

<style scoped>
.appointments {
  display: flex;
  flex-direction: column;
}

.reservation-p,
.appointment-p {
  margin-left: 10px;
}

.block {
  max-width: 100%;
  height: 100%;
  background-color: #fff;
  border-radius: 5px;
  color: rgba(0, 0, 0, 0.87);
  margin: 10px 7px 7px 0;
  padding: 10px;
  color: #01437a;
  cursor: pointer;
}

.appointment {
  font-size: 12px;
  color: #fff;
  background: #04a5ec;
}

.reservation {
  font-size: 12px;
  color: #fff;
  background: #4caf50;
}

.subtitle {
  font-size: 17px;
  margin: 20px 10px;
}

.btn-confirm {
  background: #4caf50 !important;
  margin-left: 0px !important;
  color: #fff !important;
  font-weight: 800 !important;
  text-transform: none !important;
  max-width: 100%;
}

.btn-regular {
  background: #04a5ec !important;
  margin-left: 0px !important;
  color: #fff !important;
  font-weight: 800 !important;
  text-transform: none !important;
  max-width: 100%;
}

.appt-date {
  font-weight: 700;
  margin-bottom: 5px;
}
</style>
